import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  svg {
    position: absolute;
    top: 18px;
    right: 10px;
  }
`;

export const Selected = styled.select`
  width: 190px;
  height: 48px;
  font-size: 16px;
  font-weight: 400;
  padding: 0 20px;
  border: 1.5px solid #dfe4ef;
  box-sizing: border-box;
  border-radius: 4px;
  color: ${(props) => props.theme.colors.black};
  background: ${(props) => props.theme.colors.white};
  -webkit-appearance: none;

  @media screen and (max-width: 960px) {
    width: 150px;
  }
`;

export const Option = styled.option`
  box-sizing: border-box;
  border: none;
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.gray};
`;
